export const INVALID_FILE_TYPE_CODE = "file-invalid-type";
export const INVALID_FILE_SIZE_CODE = "file-too-large";
export const INVALID_FILE_COUNT_CODE = "too-many-files";

export const MAX_FILES_COUNT_VIDEOS = 3;
export const ERROR_MAX_VIDEOS = `You can add up to ${MAX_FILES_COUNT_VIDEOS} videos`;
export const MAX_FILES_COUNT_IMAGES = 10;
export const ERROR_MAX_IMAGES = `You can add up to ${MAX_FILES_COUNT_IMAGES} images`;
